import { SearchInput } from '@tonic-one/react';

const Searcher = (props: {
  filterParams: any;
  setFilterParams: (filterParams: any) => void;
  placeholder: string;
}) => {
  const onChange = (e: any) => {
    props.setFilterParams({
      ...props.filterParams,
      input: e.target.value,
    });
  };
  const onKeyUp = (e: any) => {
    if (e.key === 'Enter') {
      props.setFilterParams({
        ...props.filterParams,
        page: 1,
        trigger: new Date().valueOf(),
      });
    }
  };

  const onClearInput = () => {
    props.setFilterParams({
      ...props.filterParams,
      input: '',
      page: 1,
      trigger: new Date().valueOf(),
    });
  };

  return (
    <SearchInput
      value={props.filterParams?.input}
      width={240}
      placeholder={props.placeholder}
      mr="2x"
      onChange={onChange}
      onClearInput={onClearInput}
      onKeyUp={onKeyUp}
    />
  );
};

export default Searcher;
